module.exports = __webpack_public_path__ + "img/pm.4901a203.jpeg";